// Listen Time Report Config Settings
// Indirectly configured by `api.reportStatus.interval` Partner Setting
export const PERIODIC_REPORT_INTERVAL_SECONDS_CONFIG = 'report.listen.interval';
// Initial interval is an optional configuration that allows the listen time report to use an initial interval for an
// optional number of repeated times. As this dynamic configuration can conflict with the qualified report, these
// configurations disable the qualified report when set.
// Example:
//  10 second intervals, 10 times.
//  Then it will switch to LISTEN_TIME_REPORT_INTERVAL_SECONDS or a hard-coded fallback.
export const PERIODIC_REPORT_INITIAL_INTERVAL_SECONDS_CONFIG = 'report.listen.initial.interval.seconds';
export const PERIODIC_REPORT_INITIAL_INTERVAL_REPEAT_CONFIG = 'report.listen.initial.interval.repeat';
// Listen Time Report Constants
export const PERIODIC_REPORT_INTERVAL_SECONDS = 300;
export const QUALIFIED_REPORT_INTERVAL_MS = 60_000;
export const DURATION_THRESHOLD_IN_SECONDS = 5;
// failure status reports can only be sent within first 10 minutes of session start
export const FAILURE_STATUS_REPORT_THRESHOLD = 600_000;
// minimum buffer duration for reporting
export const BUFFER_DURATION_REPORTING_THRESHOLD = 5000;
export const commands = {
    timev3: 'timev3',
    stream: 'stream',
    buffer: 'buffer',
};
export const triggers = {
    periodic: 'periodic',
    fail: 'fail',
    pause: 'pause',
    stop: 'stop',
    end: 'end',
    shiftRewind: 'shift_rw',
    shiftFastForward: 'shift_ff',
};
